export default "__VITE_ASSET__B9M6FzIQ__"